import audioPlayer from './audioPlayer.js';
let nav = {
  init: function() {
    this.cacheDOM();
    this.bindEvents();
  },
  cacheDOM: function() {
    this.$nav = document.querySelector('nav');
  this.$scoreWrapper = this.$nav.querySelector('.nav-score-wrapper');
  this.$scoreToggle = this.$nav.querySelector('.score-toggle');
    this.$chaptersWrapper = this.$nav.querySelector('.nav-chapters-wrapper');
    this.$logo = this.$nav.querySelector('.tt');
    this.$startOver = document.querySelector('.start-over-wrapper');
    this.$chaptersDropdown = document.getElementById('chapters-dropdown');
    this.$scoreDropdown = document.getElementById('score-dropdown');
    this.$chapterItems = this.$chaptersDropdown ? this.$chaptersDropdown.querySelectorAll('.chapter') : [];
    this.$nomineeItems = this.$chaptersDropdown ? this.$chaptersDropdown.querySelectorAll('.nominee') : [];
      this.$pagesContainer = document.querySelector('.pages-container');
      this.$pages = this.$pagesContainer ? this.$pagesContainer.querySelectorAll('.page') : [];
    this._desktopMQ = window.matchMedia('(min-width: 768px)');
  },
  refreshPages: function() {
    // Re-cache pages & container dimensions after a layout mode switch (desktop <-> mobile) or major resize
    this.$pagesContainer = document.querySelector('.pages-container');
    this.$pages = this.$pagesContainer ? this.$pagesContainer.querySelectorAll('.page') : [];
  },
  bindEvents: function() {
    // Score toggle
    if (this.$scoreToggle) {
      this.$scoreToggle.addEventListener('click', () => this.toggleDropdown(this.$scoreDropdown));
      this.$scoreToggle.addEventListener('keydown', (e) => { if (['Enter',' '].includes(e.key)) { e.preventDefault(); this.toggleDropdown(this.$scoreDropdown); }});
    }
    // Refresh pages on resize and breakpoint changes to keep navigation accurate
    if (this.$pagesContainer) {
      let resizeScheduled = false;
      window.addEventListener('resize', () => {
        if (resizeScheduled) return;
        resizeScheduled = true;
        requestAnimationFrame(() => {
          this.refreshPages();
          resizeScheduled = false;
        });
      });
      if (this._desktopMQ) {
        this._desktopMQ.addEventListener('change', () => {
          this.refreshPages();
        });
      }
    }
    // Score close icon inside wrapper (if present)
    if (this.$scoreWrapper) {
      const scoreClose = this.$scoreWrapper.querySelector('.close');
      if (scoreClose) {
        const activate = (e) => {
          if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
          if (e.type === 'keydown') e.preventDefault();
          this.toggleDropdown(this.$scoreDropdown);
        };
        scoreClose.setAttribute('tabindex','0');
        scoreClose.addEventListener('click', activate);
        scoreClose.addEventListener('keydown', activate);
      }
    }
    // Chapters wrapper
    if (this.$chaptersWrapper) {
      const chaptersActivate = (e) => {
        if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
        if (e.type === 'keydown') e.preventDefault();
        // If a slideshow modal is open, use this as the close mechanism
        const openShow = document.querySelector('.nav-dropdown.slideshow.open');
        if (openShow) {
          // Prefer slideshow's own close to ensure state reset
          const id = openShow.getAttribute('data-id');
          if (typeof window.closeSlideshow === 'function' && id) {
            window.closeSlideshow(id);
            return;
          }
          // Fallback: legacy manual close
          openShow.classList.add('closing');
          const handle = (evt) => {
            if (evt.target !== openShow) return;
            openShow.classList.remove('closing','above');
            openShow.removeEventListener('transitionend', handle);
          };
          openShow.addEventListener('transitionend', handle);
          openShow.classList.remove('open');
          openShow.setAttribute('aria-hidden','true');
          openShow.setAttribute('aria-modal','false');
          const lbl = this.$chaptersWrapper.querySelector('.label');
          if (lbl) lbl.textContent = 'MENU';
          this.$chaptersWrapper.classList.remove('open');
          return;
        }
        // Otherwise, toggle chapters dropdown as usual
        this.toggleDropdown(this.$chaptersDropdown);
        this.updateChaptersIcon();
      };
      this.$chaptersWrapper.addEventListener('click', chaptersActivate);
      this.$chaptersWrapper.addEventListener('keydown', chaptersActivate);
    }
    // Logo scroll
    if (this.$logo) {
      this.$logo.addEventListener('click', () => this.scrollToStart());
      this.$logo.addEventListener('keydown', (e) => { if (['Enter',' '].includes(e.key)) { e.preventDefault(); this.scrollToStart(); }});
    }
    // Start over button scroll
    if (this.$startOver) {
      const activate = (e) => {
        if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
        if (e.type === 'keydown') e.preventDefault();
        this.scrollToStart();
      };
      this.$startOver.addEventListener('click', activate);
      this.$startOver.addEventListener('keydown', activate);
    }
    // Chapter items
    if (this.$chapterItems && this.$chapterItems.length) {
      this.$chapterItems.forEach(item => {
        const handler = (e) => {
          if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
          if (e.type === 'keydown') e.preventDefault();
          // Close the chapters dropdown before navigating/opening
          if (this.$chaptersDropdown && this.$chaptersDropdown.classList.contains('open')) {
            this.closeDropdown(this.$chaptersDropdown);
          }
          // If this chapter maps to a slideshow modal, open it instead of scrolling
          const targetId = item.dataset.pageLink;
          const slideshow = document.querySelector(`.nav-dropdown.slideshow[data-id="${targetId}"]`);
          if (slideshow && typeof window.openSlideshow === 'function') {
            // Open slideshow after closing chapters
            window.openSlideshow(targetId);
            return;
          }
          // Otherwise, navigate to the corresponding page
          this.scrollToPage(targetId, { behavior: 'instant' });
        };
        item.setAttribute('tabindex','0');
        item.addEventListener('click', handler);
        item.addEventListener('keydown', handler);
      });
    }
    // Nominee items: navigate/open same target as their corresponding chapter
    if (this.$nomineeItems && this.$nomineeItems.length) {
      this.$nomineeItems.forEach(item => {
        const handler = (e) => {
          if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
          if (e.type === 'keydown') e.preventDefault();
          if (this.$chaptersDropdown && this.$chaptersDropdown.classList.contains('open')) {
            this.closeDropdown(this.$chaptersDropdown);
          }
          // Prefer explicit data-page-link on nominee; fallback to previous chapter sibling
          let targetId = item.dataset.pageLink;
          if (!targetId) {
            const prev = item.previousElementSibling;
            if (prev && prev.classList && prev.classList.contains('chapter')) {
              targetId = prev.dataset.pageLink;
            }
          }
          if (!targetId) return;
          const slideshow = document.querySelector(`.nav-dropdown.slideshow[data-id="${targetId}"]`);
          if (slideshow && typeof window.openSlideshow === 'function') {
            window.openSlideshow(targetId);
            return;
          }
          this.scrollToPage(targetId, { behavior: 'instant' });
        };
        item.setAttribute('tabindex','0');
        item.addEventListener('click', handler);
        item.addEventListener('keydown', handler);
      });
    }
    // Outside click & escape
    document.addEventListener('click', (e) => {
      const open = document.querySelectorAll('.nav-dropdown.open');
      if (!open.length) return;
      // If a modal just opened, suppress this outside-click close once
      if (window.__suppressNextOutsideClickClose) {
        window.__suppressNextOutsideClickClose = false;
        return;
      }
      const triggers = [this.$scoreWrapper, this.$chaptersWrapper];
      const clickedTrigger = triggers.some(t => t && t.contains(e.target));
      const clickedDropdown = Array.from(open).some(d => d.contains(e.target));
      if (!clickedTrigger && !clickedDropdown) this.closeAllDropdowns();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAllDropdowns(); });
    // Initial icon state
    this.updateChaptersIcon();
  },
  toggleDropdown: function(target) {
    if (!target) return;
    const isOpen = target.classList.contains('open');
    const others = Array.from(document.querySelectorAll('.nav-dropdown.open')).filter(d => d !== target);
    if (isOpen) {
      this.closeDropdown(target);
      return;
    }
    // Prepare new target on top
    target.classList.add('above');
    requestAnimationFrame(() => {
      target.classList.add('open');
      this.updateAriaState(target, true);
      if (target.id === 'chapters-dropdown' && this.$chaptersWrapper) {
        this.$chaptersWrapper.classList.add('open');
      }
      if (target.id === 'score-dropdown' && this.$scoreWrapper) {
        this.$scoreWrapper.classList.add('open');
        // Lazy-init audio player only when the score dropdown is opened
        try { audioPlayer.init(); } catch(_) {}
      }
      // Close others after new is fully visible
      const handle = (e) => {
        if (e.target !== target) return;
        target.classList.remove('above');
        others.forEach(o => this.closeDropdown(o));
        target.removeEventListener('transitionend', handle);
      };
      target.addEventListener('transitionend', handle);
    });
    if (target.id === 'chapters-dropdown') this.updateChaptersIcon();
    if (target.id === 'score-dropdown') this.updateChaptersIcon(); // keep icon in sync when switching
  },
  closeDropdown: function(drop) {
    if (!drop) return;
    // Route slideshow closes through slideshowModal to ensure proper reset
    if (drop.classList.contains('slideshow')) {
      const id = drop.getAttribute('data-id');
      if (typeof window.closeSlideshow === 'function' && id) {
        window.closeSlideshow(id);
        return;
      }
      // Fallback continues with legacy close below
    }
    // Mark as closing to keep nav state until animation completes
    drop.classList.add('closing');
    const handle = (evt) => {
      if (evt.target !== drop) return;
      drop.classList.remove('closing','above');
      drop.removeEventListener('transitionend', handle);
    };
    drop.addEventListener('transitionend', handle);
    drop.classList.remove('open');
    this.updateAriaState(drop, false);
    if (drop.id === 'chapters-dropdown') this.updateChaptersIcon();
    if (drop.id === 'chapters-dropdown' && this.$chaptersWrapper) {
      this.$chaptersWrapper.classList.remove('open');
    }
    if (drop.id === 'score-dropdown' && this.$scoreWrapper) {
      this.$scoreWrapper.classList.remove('open');
    }
  },
  closeAllDropdowns: function() {
    document.querySelectorAll('.nav-dropdown.open').forEach(d => this.closeDropdown(d));
  },
  updateAriaState: function(el, isOpen) {
    if (!el) return;
    el.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    el.setAttribute('aria-modal', isOpen ? 'true' : 'false');
  },
  updateChaptersIcon: function() {
    const chaptersDropdown = this.$chaptersDropdown;
    const hamburger = this.$chaptersWrapper && this.$chaptersWrapper.querySelector('.hamburger');
    if (!hamburger) return;
    if (chaptersDropdown && chaptersDropdown.classList.contains('open')) {
  hamburger.innerHTML = '<img src="/img/text-modal-close.svg" alt="Close" />';
    } else {
      hamburger.innerHTML = '<div class="line"></div><div class="line"></div><div class="line"></div>';
    }
  },
  scrollToStart: function() {
    const container = document.querySelector('.pages-container');
    if (!container) return;
    // If zoom modal is open, close it before scrolling to start
    if (window.pageZoom && window.pageZoom.active && typeof window.pageZoom.close === 'function') {
      window.pageZoom.close();
    }
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const startTime = performance.now();
    const duration = 500;
    const initialX = container.scrollLeft;
    const initialY = container.scrollTop;
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
    function step(now) {
      const t = Math.min(1, (now - startTime) / duration);
      const eased = easeOutCubic(t);
      if (isDesktop) container.scrollLeft = initialX * (1 - eased); else container.scrollTop = initialY * (1 - eased);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  },
  scrollToPage: function(pageId, opts = {}) {
      const container = document.querySelector('.pages-container');
      if (!container) return;
      // Accept optional options object as second arg
      let skipZoomClose = false;
      if (typeof pageId === 'object' && pageId !== null) {
        // Called as scrollToPage(pageId, { skipZoomClose: true })
        skipZoomClose = !!pageId.skipZoomClose;
        pageId = pageId.pageId;
      }
      const behavior = opts.behavior || 'animated'; // 'animated' | 'instant'
      // If zoom modal is open, close it before scrolling to target page (unless skipZoomClose)
      if (!skipZoomClose && window.pageZoom && window.pageZoom.active && typeof window.pageZoom.close === 'function') {
        window.pageZoom.close();
      }
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const targetPage = container.querySelector(`.page[data-id="${pageId}"]`);
    if (!targetPage) return;
    // Close chapters if open
    if (this.$chaptersDropdown && this.$chaptersDropdown.classList.contains('open')) {
      this.closeDropdown(this.$chaptersDropdown);
    }

    // Smooth scroll animation
    function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
    function animateTo(finalX, finalY, duration) {
      if (typeof duration === 'undefined') duration = 650;
      var startTime = performance.now();
      var initialX = container.scrollLeft;
      var initialY = container.scrollTop;
      function step(now) {
        var t = Math.min(1, (now - startTime) / duration);
        var eased = easeOutCubic(t);
        if (isDesktop) {
          container.scrollLeft = initialX + (finalX - initialX) * eased;
        } else {
          container.scrollTop = initialY + (finalY - initialY) * eased;
        }
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    const computeFinalOffsets = () => {
      let finalX = targetPage.offsetLeft;
      let finalY = targetPage.offsetTop;
      if (isDesktop) {
        // Desktop: align the target page's left edge with the container's left edge (no centering)
        finalX = targetPage.offsetLeft; // left-align
      } else {
        const navHeight = parseInt(getComputedStyle(document.querySelector('nav')).height, 10) || 0;
        finalY = targetPage.offsetTop - navHeight - 18; // offset past nav
      }
      return { finalX, finalY };
    };

    // Preload surrounding pages to reduce later layout shifts
    this.preloadSurroundingPages(targetPage);

    // Initial scroll
    const first = computeFinalOffsets();
    if (behavior === 'instant') {
      if (isDesktop) {
        container.scrollLeft = first.finalX;
      } else {
        container.scrollTop = first.finalY;
      }
    } else {
      animateTo(first.finalX, first.finalY);
    }

    // Re-align after image decode or load (target only)
    const img = targetPage.querySelector('img');
  if (behavior !== 'instant' && img && !img.complete) {
      // Attempt to raise priority
      try { img.fetchPriority = 'high'; } catch(_){}
      if (img.decode) {
        img.decode().then(() => {
          const { finalX, finalY } = computeFinalOffsets();
          animateTo(finalX, finalY, 300);
        }).catch(() => {/* ignore */});
      } else {
        const handleLoad = () => {
          const { finalX, finalY } = computeFinalOffsets();
          animateTo(finalX, finalY, 300);
        };
        img.addEventListener('load', handleLoad, { once: true });
      }
    }

    // Stability sampling: adjust once layout stops shifting or timeout
    if (behavior !== 'instant') {
      this._stabilizeScroll(targetPage, isDesktop, () => {
        const { finalX, finalY } = computeFinalOffsets();
        // Only animate correction if meaningful delta to reduce perceptible twitch
        const delta = isDesktop ? Math.abs(container.scrollLeft - finalX) : Math.abs(container.scrollTop - finalY);
        if (delta > 6) {
          animateTo(finalX, finalY, 220);
        } else {
          if (isDesktop) container.scrollLeft = finalX; else container.scrollTop = finalY;
        }
      });
    }
  },
  /**
   * Sample target position until it stops shifting (due to late image loads) then invoke cb.
   */
  _stabilizeScroll: function(targetPage, isDesktop, cb) {
    const MAX_TIME = 1800; // ms
    const INTERVAL = 90; // ms
    const STABLE_SAMPLES = 3; // consecutive stable readings
    let stableCount = 0;
    let lastPos = null;
    const start = performance.now();
    const sample = () => {
      const pos = isDesktop ? targetPage.offsetLeft : targetPage.offsetTop;
      if (lastPos !== null && Math.abs(pos - lastPos) < 2) {
        stableCount++;
      } else {
        stableCount = 0;
      }
      lastPos = pos;
      const elapsed = performance.now() - start;
      if (stableCount >= STABLE_SAMPLES || elapsed > MAX_TIME) {
        cb && cb();
        return;
      }
      setTimeout(sample, INTERVAL);
    };
    sample();
  },
  /**
   * Preload target page image and a few neighbors to reduce layout shift before/after navigation.
   */
  preloadSurroundingPages: function(targetPage) {
    if (!this.$pages || !this.$pages.length) return;
    const pagesArr = Array.from(this.$pages);
    const idx = pagesArr.indexOf(targetPage);
    if (idx === -1) return;
    const toPreload = [];
    for (let i = idx - 2; i <= idx + 2; i++) {
      if (i < 0 || i >= pagesArr.length) continue;
      toPreload.push(pagesArr[i]);
    }
    toPreload.forEach(p => {
      const img = p.querySelector('img');
      if (!img) return;
      if (img.complete) return; // already loaded
      try { img.fetchPriority = 'high'; } catch(_){}
      const src = img.getAttribute('src');
      if (!src) return;
      const pre = new Image();
      pre.src = src;
    });
  },
}
export default nav;